import { MintWithAmount, NonSpecificActionFilled } from "@malloc-protocol/sdk";
import React, { useState, FC, ReactNode } from "react";
import { useStore } from "react-stores";
import { globalStore } from "../globalStore";
import TokenLine from "./tokens/TokenLine";

const EstimateLines = (props: { mints: string[]; amounts: string[] }) => {
  const { mints, amounts } = props;

  return (
    <>
      {mints.map((m, i) => {
        return <TokenLine mint={m} amount={amounts[i]} key={`Estimate-line-${i}-${m.toString()}`}/>;
      })}
    </>
  );
};

const isVis = (estimates?: MintWithAmount<string, string>[]): boolean => {
  return estimates !== undefined;
};

const EstimatesPanel: FC = () => {
  const state = useStore(globalStore);
  const selectedAction = state.context.nodes[state.context.selectedNodeId];
  const NSPConstructionNode = (
    state.construction.actionDatas[selectedAction.id] as any
  ).action as NonSpecificActionFilled;

  return (
    <div className="card" style={{}}>
      <h3>Estimates</h3>
      <div>
        <h4>Expected In</h4>
        {isVis(NSPConstructionNode.inEstimates) || (
          <p>We can only give estimates once the entire flow can be built!</p>
        )}
        {isVis(NSPConstructionNode.inEstimates) && (
          <EstimateLines
            mints={NSPConstructionNode.inEstimates!.map((e) => e.mint)}
            amounts={NSPConstructionNode.inEstimates!.map((e) => e.amount)}
          />
        )}
      </div>
      <div>
        {isVis(NSPConstructionNode.outEstimates) || (
          <>
            <h4>Expected Out</h4>
            <p>We can only give estimates once the entire flow can be built!</p>
          </>
        )}
        {isVis(NSPConstructionNode.outEstimates) &&
          NSPConstructionNode.outEstimates!.length > 0 && (
            <>
              <h4>Expected Out</h4>
              <EstimateLines
                mints={NSPConstructionNode.outEstimates!.map((e) => e.mint)}
                amounts={NSPConstructionNode.outEstimates!.map((e) => e.amount)}
              />
            </>
          )}
      </div>
    </div>
  );
};

export default EstimatesPanel;
